import type { ReactNode } from 'react';
import styles from './DashboardLayout.module.scss';

export interface DashboardLayoutProps {
  title: string;
  actions?: ReactNode;
  children: ReactNode;
}

const DashboardLayout = ({ title, actions, children }: DashboardLayoutProps) => (
  <div className={styles.root}>
    <div className={styles.header}>
      <h1 className={styles.title}>{title}</h1>
      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
    <div className={styles.tableContainer}>
      {children}
    </div>
  </div>
);

export { styles as dashboardStyles };
export default DashboardLayout;
